import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

// Components
import LabelArtistName from 'components/interestform/formcomponents/labelartistname'
import Links from 'components/interestform/formcomponents/links'
import Distributor from 'components/interestform/formcomponents/distributor'
import DistributorNote from 'components/interestform/formcomponents/distributornote'

// Types
import type { Link } from 'components/interestform/formcomponents/links/links'
import { PageVariants } from 'types'

// Utils
import commonStyles from 'components/interestform/slides/common.css'
import styles from './cataloginformation.css'

export type Distributor = {
  id: string
  distributor_name: string
  distributor_note: string
}

type CatalogInformationProps = {
  distributorOptions: Array<Distributor>
  values: {
    links: Array<Link>
    distributor: string
    other_distributor: string
    publishing_owner: string
  }
  pageVariants: PageVariants
}

const CatalogInformation = (props: CatalogInformationProps) => {
  const { values, distributorOptions, pageVariants } = props
  const [distributorObj, setDistributorObj] = useState<Distributor | null | undefined>(null)

  const distributorData = {
    distributor: values.distributor,
    otherDistributor: values.other_distributor,
  }

  useEffect(() => {
    const obj = distributorOptions.find(o => o.distributor_name === values.distributor)
    setDistributorObj(obj)
  }, [values.distributor, distributorOptions])

  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>
        Catalog Information
        <span className={styles.requiredStar}>*</span>
      </h1>
      <div className={styles.subheading}>First we need you to tell us a bit about your music and where we can hear it! </div>
      <div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>What is your Label or Artist name?</div>
          <div className={styles.questionDetails}>
            We can only opt in one label at a time. If you have sub labels or multiple personas, you will need to opt those in separately
          </div>
          <LabelArtistName onReview={false} />
        </div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>Where can we review your music?</div>
          <div className={styles.questionDetails}>
            A Spotify playlist, a website, Soundcloud, any links containing your music! We need at least one link from you, and please make
            sure there is no additional login required
          </div>
          <Links onReview={false} links={values.links} />
        </div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>Who is your Distributor?</div>
          <div className={styles.questionDetails}>We need to know who your distributor is so that we can sort out the business stuff!</div>
          <Distributor onReview={false} distributorData={distributorData} distributorOptions={distributorOptions} />
          {distributorObj && distributorObj.distributor_note !== '' ? <DistributorNote note={distributorObj.distributor_note} /> : null}
        </div>
      </div>
    </motion.div>
  )
}

export default CatalogInformation
